import { useMutation } from "@apollo/client";
import { SetUserTaxProfileMutation, SetUserTaxProfileMutationVariables } from "@ctypes";
import { SET_USER_TAX_PROFILE, USER } from "@graphql";

export const useSetUserTaxProfile = () => {
  return useMutation<SetUserTaxProfileMutation, SetUserTaxProfileMutationVariables>(
    SET_USER_TAX_PROFILE,
    {
      refetchQueries: [USER],
      awaitRefetchQueries: true,
    },
  );
};
